const COMPARE_PRICE_CLASS = 'lbr-subscription-compare-price';

function parsePriceToken(token) {
  const compact = token.replace(/\s/g, '');
  const lastSeparator = Math.max(compact.lastIndexOf('.'), compact.lastIndexOf(','));
  const decimalLength = lastSeparator >= 0 ? compact.length - lastSeparator - 1 : 0;
  const hasDecimals = decimalLength > 0 && decimalLength <= 2;
  const decimalSeparator = hasDecimals ? compact[lastSeparator] : '';
  const normalized = hasDecimals
    ? `${compact.slice(0, lastSeparator).replace(/[.,]/g, '')}.${compact.slice(lastSeparator + 1)}`
    : compact.replace(/[.,]/g, '');

  return {
    decimalLength: hasDecimals ? decimalLength : 0,
    decimalSeparator,
    value: Number(normalized),
  };
}

function formatPriceLike(value, format) {
  const [whole, decimals] = value.toFixed(format.decimalLength).split('.');
  return format.decimalLength ? `${whole}${format.decimalSeparator}${decimals}` : whole;
}

function updateSubscriptionComparePrice(productInformation) {
  const currentPrice = productInformation.querySelector('[data-product-price]');
  const priceGroup = currentPrice?.closest('.product-price-group');
  const existingComparePrice = priceGroup?.querySelector(`.${COMPARE_PRICE_CLASS}`);
  const originalValue = Number(currentPrice?.getAttribute('content'));
  const currentText = currentPrice?.textContent.trim() || '';
  const priceMatch = currentText.match(/\d[\d\s.,]*/);
  const parsedCurrentPrice = priceMatch ? parsePriceToken(priceMatch[0]) : null;

  if (
    !currentPrice
    || !priceGroup
    || !originalValue
    || !parsedCurrentPrice?.value
    || Math.abs(originalValue - parsedCurrentPrice.value) < 0.005
  ) {
    existingComparePrice?.remove();
    return;
  }

  const originalText = currentText.replace(
    priceMatch[0],
    formatPriceLike(originalValue, parsedCurrentPrice),
  );
  const comparePrice = existingComparePrice || document.createElement('span');

  if (!existingComparePrice) {
    comparePrice.className = COMPARE_PRICE_CLASS;
    currentPrice.before(comparePrice);
  }

  if (comparePrice.textContent !== originalText) comparePrice.textContent = originalText;
}

function initializeSubscriptionComparePrices() {
  document.querySelectorAll('product-information').forEach((productInformation) => {
    if (productInformation.dataset.subscriptionComparePriceInitialized === 'true') return;

    productInformation.dataset.subscriptionComparePriceInitialized = 'true';
    let updateTimer;
    const queueUpdate = () => {
      window.clearTimeout(updateTimer);
      updateTimer = window.setTimeout(() => updateSubscriptionComparePrice(productInformation), 50);
    };

    new MutationObserver(queueUpdate).observe(productInformation, {
      attributes: true,
      attributeFilter: ['content'],
      characterData: true,
      childList: true,
      subtree: true,
    });

    productInformation.addEventListener('change', queueUpdate);
    productInformation.addEventListener('click', queueUpdate);
    queueUpdate();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeSubscriptionComparePrices, { once: true });
} else {
  initializeSubscriptionComparePrices();
}

document.addEventListener('shopify:section:load', initializeSubscriptionComparePrices);
